<template>
    <b-list-group class="block__commercialResume">
      <b-list-group-item v-for="(list,index) in lists" :key="index" :class="{negatif : list.negatif}">
        <div class="fullname">
          <PuSkeleton :loading="isLoading" :count="1" height="20px">                                        
            {{list.fullname}}
          </PuSkeleton>
        </div>
        <div class="right">
          <PuSkeleton :loading="isLoading" :count="1" height="20px" width="20px">
            <span>
              <font-awesome-icon :icon="['far', list.icon]" />
            </span>

            <div class="number">{{list.number}}</div>
          </PuSkeleton>
        </div>
      </b-list-group-item>
    </b-list-group>
</template>


<script>
import { mapGetters } from 'vuex'
//
export default {
  name: "ListCommercialResume",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getListsCommercialResume'
      ])
    },  
  props:{
    // lists:{
    //   type:Object
    // }
  },
  data(){
    return { 
      lists:"",
      isLoading:true,
    }
  },
  created (){
    this.lists = this.getListsCommercialResume;
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }
}
</script>